const languages = ['en', 'nl', 'fr']
export default languages
